// extracted by mini-css-extract-plugin
export var fullHeightState = "_5b-7";
export var headerCell = "_5b-1";
export var loadingStateCell = "_5b-4";
export var rowWrapper = "_5b-3";
export var standaloneTable = "_5b-8";
export var standaloneTableWithBodyFill = "_5b-9";
export var stateCell = "_5b-5";
export var table = "_5b-0";
export var tableBodyFiller = "_5b-6";
export var white = "_5b-2";